import React from 'react';

import { Box, Flex, Text, Skeleton, Button } from '@vimeo/bokeh';

import { useHelpPanel } from '../hooks/useHelpPanel';
import { HelpArticle } from '../types';
import { truncateContent, removeHtmlAndTruncate } from '../utils/helper';

export const SearchPanel: React.FC = () => {
  const { data, goToArticle, isSearching, searchQuery } = useHelpPanel();
  const searchResults: HelpArticle[] = data.search || [];

  if (isSearching) {
    return (
      <Box gap={4} width="320px">
        {[...Array(10)].map((_, index) => (
          <Flex key={index} direction="column" gap="sm" mt="lg">
            {[...Array(2)].map((_, index) => (
              <Skeleton key={index} height="sm" borderRadius="sm" width="100%" />
            ))}
            <Skeleton height="sm" borderRadius="sm" width="223px" />
          </Flex>
        ))}
      </Box>
    );
  }

  if (searchResults.length === 0 && !isSearching) {
    return <Box p={4}>No results found.</Box>;
  }

  return (
    <Box>
      <Text variant="heading-md">{searchResults.length} results</Text>
      <Text as="p" variant="body-md" color="text/secondary" mb="md">
        for <b>{searchQuery}</b> in All Categories
      </Text>
      <Flex direction="column">
        {searchResults.map((article) => (
          <Flex
            as={Button}
            key={article.id}
            variant="tertiary"
            direction="column"
            width="100%"
            height="100%"
            p="lg"
            borderRadius="lg"
            alignItems="flex-start"
            onClick={() => goToArticle(article)}
          >
            <Flex flex={1} direction="column" textAlign="left">
              <Text variant="heading-xs">{truncateContent(article.title, 30)}</Text>
              <Text variant="body-md" whiteSpace="normal">
                {removeHtmlAndTruncate(article.content, 85)}
              </Text>
            </Flex>
          </Flex>
        ))}
      </Flex>
    </Box>
  );
};
